import instance from "./axios.base";

const getRaiseTypes = async () => {
  const res = await instance.get("/service?name=type&tablename=hr_pr_add");
  return res.data;
};

export { getRaiseTypes };
